export default __webpack_public_path__ + "static/image4-20bf9d2b7f94b7e55c1c170a0ca94075.jpeg";